/* eslint-disable unicorn/no-null */
// mantine
import { Select, Textarea, TextInput, NumberInput } from '@mantine/core';
// components
import { CopyInput } from '@newo/ui-kit';
import type { ISettingPreset } from '@newo/api/gateway';
import Autocomplete from '@/modules/Integrations/components/Autocomplete';
import Selection from '@/modules/Integrations/components/Selection';
// utils

interface SettingFieldProps {
    control: ISettingPreset;
    onChange: (value: unknown) => void;
    value: string;
    error?: string;
}
const SettingField = ({
    control,
    onChange,
    value,
    error
}: SettingFieldProps) => {
    switch (control.control_type) {
        case 'textarea': {
            return (
                <Textarea
                    autosize
                    description={control.description}
                    error={error}
                    label={control.title}
                    maxRows={10}
                    minRows={5}
                    readOnly={control.is_readonly}
                    value={value}
                    withAsterisk={control.is_required}
                    onChange={(event) => {
                        onChange(event.currentTarget.value);
                    }}
                />
            );
        }
        case 'dropdown': {
            if (control.possible_values_url) {
                return (
                    <Autocomplete
                        description={control.description}
                        error={error}
                        label={control.title}
                        url={control.possible_values_url}
                        value={value}
                        withAsterisk={control.is_required}
                        onChange={(value_) => {
                            onChange(value_);
                        }}
                    />
                );
            }

            return (
                <Select
                    clearable
                    data={control.possible_values.map(String)}
                    description={control.description}
                    error={error}
                    label={control.title}
                    readOnly={control.is_readonly}
                    value={value}
                    withAsterisk={control.is_required}
                    onChange={onChange}
                />
            );
        }
        case 'selection': {
            return (
                <Selection
                    data={control.possible_values?.map(String) ?? null}
                    description={control.description}
                    error={error}
                    label={control.title}
                    url={control.possible_values_url}
                    value={value}
                    withAsterisk={control.is_required}
                    onChange={onChange}
                />
            );
        }
        case 'textfield': {
            if (control.is_readonly) {
                return (
                    <CopyInput
                        description={control.description}
                        label={control.title}
                        value={value}
                    />
                );
            }

            if (
                control.value_type === 'int' ||
                control.value_type === 'float'
            ) {
                return (
                    <NumberInput
                        description={control.description}
                        error={error}
                        label={control.title}
                        placeholder=""
                        readOnly={control.is_readonly}
                        value={value}
                        withAsterisk={control.is_required}
                        onChange={onChange}
                    />
                );
            }

            return (
                <TextInput
                    description={control.description}
                    error={error}
                    label={control.title}
                    readOnly={control.is_readonly}
                    value={value}
                    withAsterisk={control.is_required}
                    onChange={(event) => {
                        onChange(event.currentTarget.value);
                    }}
                />
            );
        }

        default: {
            return <div>Unknown Field</div>;
        }
    }
};

export default SettingField;
